<template lang="pug">
    v-form(ref="spvForm" id="spvForm" @submit.prevent="doSave" lazy-validation)
        v-container(grid-list-md)
            v-layout(row)
                v-flex(lg3 md3 xs12 v-if="isUpdate")
                    v-text-field(dense v-model="spv.corporateSpvId" label="Kode Supervisor" readonly)
                v-flex(lg4 md4 xs12)
                    v-text-field(dense v-model="spv.name" label="Nama" :rules="[v => !!v || 'Input Nama']" required)
            v-layout(row)
                v-flex(lg5 md5 xs12)
                    v-text-field(dense v-model="spv.email" label="Email" :rules="[v => !!v || 'Input Email', v => /.+@.+\..+/.test(v) || 'E-mail tidak valid']" required)
                v-flex(lg2 md2 xs12)
                    v-text-field(dense v-model="spv.phone" label="No. Handphone" )
            div(justify-center style="text-align: center" class="ma-2 menu-btn")
                v-btn(class="mx-1" @click="doCancel") Kembali
                    v-icon mdi-arrow-left
                v-btn(color="btnprimary white--text" class="mx-1" type="submit" form="spvForm") Simpan
                    v-icon mdi-content-save-outline
</template>
<script>
export default {
    name: "FSpvForm",
    props: ["isUpdate", "dataSpv"],
    data() {
        return {
            spv: {
                corporateId: "",
                corporateSpvId: null,
                name: "",
                phone: "",
                email: ""
            }
        }
    },
    watch: {
        dataSpv(val){
            this.doInit(val);
        }
    },
    mounted() {
        this.doInit(this.dataSpv);
        
    },
    methods: {
        doInit(values){
            this.spv = values ? values : {
                corporateId: "",
                corporateSpvId: null,
                name: "",
                phone: "",
                email: ""
            }
            if (this.$refs.spvForm) {
                this.$refs.spvForm.resetValidation();
            }
        },
        doSave(){
            if (this.$refs.spvForm.validate()) {
                this.$refs.spvForm.resetValidation();
                this.$emit("spv", this.spv);
            }
        },
        doCancel(){
            this.$refs.spvForm.resetValidation();
            this.$emit("cancel");
        }
    },
}
</script>